<template>
    <div id="hotelDetailsWrapper">
        <USPBanner v-if="uspBannerVisible" />
        <component :is="component" v-bind="{ hotel, marker, teaser, hotelDetails }" />
    </div>
</template>

<script>
import Marker from '@/models/Marker';
import getHead from '@/mixins/getHead';
import HotelDetailsDesktop from '@/components/hotel/HotelDetailsDesktop';
import HotelDetailsMobile from '@/components/hotel/HotelDetailsMobile';
import advertisable from '@/mixins/advertisable';
import fetchResource from '@/utils/fetchResource';

export default {
    name: 'HotelDetails',
    layout: ({ layout }) => layout,
    mixins: [getHead, advertisable('hotel')],
    async fetch(context) {
        await fetchResource(context, context.store.dispatch('getHotel', context.params.hotelId));
    },
    head() {
        return this.getHead({
            ...this.pageData,
            pageTitle: this.hotelDetails.name
        });
    },
    components: {
        HotelDetailsMobile,
        HotelDetailsDesktop
    },
    computed: {
        component() {
            if (this.$root.isMobile) {
                return 'HotelDetailsMobile';
            }
            return 'HotelDetailsDesktop';
        },
        hotel() {
            return this.$store.state.hotel;
        },
        teaser() {
            //now for desktop. For mobile teaser should be combined with images
            const { teaserImageUrl } = this.pageData;
            return { imageUrl: teaserImageUrl };
        },
        marker() {
            const [lat, lng] = this.hotelDetails.latLon || [];
            const { name, street, city, zipcode } = this.hotelDetails;
            const routeURL = `//google.com/maps/dir/Current+Location/${street}+${city}+${zipcode}`;
            return new Marker(lat, lng, {
                name,
                street,
                city,
                zipcode,
                routeURL
            });
        },
        pageData() {
            return this.hotel.pageData || {};
        },
        hotelDetails() {
            return this.hotel.hotelDetails || {};
        }
    },
    methods: {
        sendGTMEvent() {
            this.$gtm && this.$gtm.pushHotelDetailsPageData(this.hotel);
        }
    },
    beforeMount() {
        this.sendGTMEvent();
    }
};
</script>

<style scoped lang="scss">
#hotel {
    .font-larger {
        font-size: 17px;
    }

    .hotel-name,
    .hotel-classification {
        margin-bottom: 20px;
    }

    .hotel-name {
        font-size: 28px;
        line-height: 28px;
        font-weight: 700;
    }

    .hotel-classification {
        justify-content: center;
        font-size: 28px;
        color: var(--body-color);

        ::v-deep > * {
            margin-left: 7px;
            margin-right: 7px;
        }

        ::v-deep .animod-stars,
        ::v-deep .superior {
            font-size: 20px;
        }
    }
}
</style>
